import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from '@/components/ui/sidebar'
import { NavGroup } from '@/components/layout/nav-group'
import { NavUser } from '@/components/layout/nav-user'
import { ShopSwitcher } from '@/components/layout/shop-switcher'
import { isPlatformAdmin } from '@/lib/platform-admin'
import { useAuthStore } from '@/stores/authStore'
import { sidebarData } from './data/sidebar-data'

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const user = useAuthStore((s) => s.auth.user)
  const visibleGroups = sidebarData.navGroups.filter(
    (group) =>
      (!group.adminOnly || isPlatformAdmin(user)) && group.items.length > 0
  )

  return (
    <Sidebar collapsible='icon' variant='floating' {...props}>
      <SidebarHeader>
        <ShopSwitcher />
      </SidebarHeader>
      <SidebarContent>
        {visibleGroups.map((group) => (
          <NavGroup key={group.title} {...group} />
        ))}
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={sidebarData.user as any} />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  )
}
